import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApi,
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

type ReadCustomFieldsV3 = OpalApi<'ReadCustomFieldsV3', 200>

export const readCustomFields: ReadCustomFieldsV3 = async ({
  params,
}: Parameters<ReadCustomFieldsV3>[0] = {}) => {
  const url = new URL('/loupe/v3/custom_fields', window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}

type ReadCustomFieldOperation = 'ReadCustomFieldV3'

export type ReadCustomFieldResponse = OpalApiResponseDocument<
  ReadCustomFieldOperation,
  200
>

export function readCustomField(
  params: OpalApiRequestParams<ReadCustomFieldOperation>
): Promise<ReadCustomFieldResponse> {
  const url = new URL(
    `/loupe/v3/custom_fields/${params.path.custom_field_id}`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
